import { ElementType, ISurveyElement, ISurveyQuestionEditModel, QuestionType } from '../models';

// Groups together survey questions with the same response option group and is a scale question
// So that we can surround those groups with a border
// Any other element occupies a group of one
const GroupSummarySurveyElements = (elements: ISurveyElement[]): ISurveyElement[][] => {
	const groupings = [];
	let startGroupIndex = 0;
	let grouping;

	for (let i = 0; i < elements.length - 1; i++) {
		const currentElement = elements[i];
		const nextElement = elements[i + 1];

		if (
			currentElement.elementType === ElementType.Question &&
			nextElement.elementType === ElementType.Question &&
			currentElement.isRandomized &&
			nextElement.isRandomized
		) {
			const currentQuestion = currentElement as ISurveyQuestionEditModel;
			const nextQuestion = nextElement as ISurveyQuestionEditModel;
			if (
				!(
					currentQuestion.sourceResponseOptionGroupId &&
					nextQuestion.sourceResponseOptionGroupId &&
					currentQuestion.sourceResponseOptionGroupId === nextQuestion.sourceResponseOptionGroupId &&
					currentQuestion.questionType === QuestionType.Scale &&
					nextQuestion.questionType === QuestionType.Scale
				)
			) {
				grouping = elements.slice(startGroupIndex, i + 1);
				groupings.push(grouping);
				startGroupIndex = i + 1;
			}
		} else {
			grouping = elements.slice(startGroupIndex, i + 1);
			groupings.push(grouping);
			startGroupIndex = i + 1;
		}
	}

	// account for final item
	grouping = elements.slice(startGroupIndex, elements.length + 1);
	groupings.push(grouping);

	return groupings;
};

const GroupSurveyElements = (
	elementsToGroup: ISurveyElement[],
	isSorting: boolean,
): { groupingIndexStart: number; groupingIndexEnd: number }[] => {
	const groupings: { groupingIndexStart: number; groupingIndexEnd: number }[] = [];
	if (isSorting) {
		return groupings;
	}
	let startGroupIndex = 0;

	for (let i = 0; i < elementsToGroup.length - 1; i++) {
		const currentElement = elementsToGroup[i];
		const nextElement = elementsToGroup[i + 1];

		if (
			currentElement.elementType === ElementType.Question &&
			nextElement.elementType === ElementType.Question &&
			currentElement.isRandomized &&
			nextElement.isRandomized
		) {
			const currentQuestion = currentElement as ISurveyQuestionEditModel;
			const nextQuestion = nextElement as ISurveyQuestionEditModel;
			if (
				!(
					currentQuestion.sourceResponseOptionGroupId &&
					nextQuestion.sourceResponseOptionGroupId &&
					currentQuestion.sourceResponseOptionGroupId === nextQuestion.sourceResponseOptionGroupId &&
					currentQuestion.questionType === QuestionType.Scale &&
					nextQuestion.questionType === QuestionType.Scale
				)
			) {
				groupings.push({ groupingIndexStart: startGroupIndex, groupingIndexEnd: i });
				startGroupIndex = i + 1;
			}
		} else {
			groupings.push({ groupingIndexStart: startGroupIndex, groupingIndexEnd: i });
			startGroupIndex = i + 1;
		}
	}

	// account for final item
	groupings.push({ groupingIndexStart: startGroupIndex, groupingIndexEnd: elementsToGroup.length - 1 });

	// add one to each index because sequence begins at 1 not 0
	const resultGroupings = groupings.map((g) => {
		return { groupingIndexStart: g.groupingIndexStart + 1, groupingIndexEnd: g.groupingIndexEnd + 1 };
	});
	return resultGroupings.filter((g) => g.groupingIndexEnd - g.groupingIndexStart > 0);
};
export const RandomizedItemGroupingHelper = {
	GroupSurveyElements,
	GroupSummarySurveyElements,
};
